import { Modal } from "react-bootstrap";

const FlashTermAndCondModal = (props)=>{

    const {showModal,setShowModal} = props;
    
    return(
        <>
        <Modal show={showModal} dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title" onHide={() => setShowModal(false)}>
<Modal.Header closeButton>
</Modal.Header>
        <Modal.Body>
        <section class="terms-con-flas">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h1 className="mb-3">Terms and Conditions for Flash Sale</h1>
                <h2>10% Off All Paid Courses</h2>
 
                <p><strong>Effective Date:</strong> December 11, 2024</p>
                <p><strong>End Date:</strong> December 12, 2024</p>
 
                <p>By participating in the Flash Sale, you agree to the following terms and conditions:</p>
 
                <h4>Offer Details</h4>
                <ul>
                    <li>A 10% discount is applicable on all paid courses available on the C21 Path to Gold platform.
                    </li>
                    <li>The offer is valid from 12:00 AM EST on December 11, 2024, to 11:59 PM EST on Dec 12, 11:59 PM.
                    </li>
                </ul>
 
                <h4>Eligibility</h4>
                <ul>
                    <li>The offer is available to all registered users of the C21 Path to Gold platform.</li>
                    <li>Users must complete the purchase within the promotional period to be eligible for the discount.
                    </li>
                </ul>
 
                <h4>Exclusions</h4>
                <ul>
                    <li>The discount does not apply to free courses, subscription plans, or other promotional bundles.
                    </li>
                    <li>This offer cannot be combined with any other discounts, promotions, or coupon codes.</li>
                </ul>
 
                <h4>Redemption</h4>
                <ul>
                    <li>Use code <strong>XSEL10</strong> at checkout for eligible purchases.</li>
                </ul>
 
                <h4>Payment and Refunds</h4>
                <ul>
                    <li>Standard payment policies apply.</li>
                    <li>Refunds for courses purchased during the promotional period will be processed at the discounted
                        rate.</li>
                </ul>
 
                <h4>Changes or Cancellation</h4>
                <ul>
                    <li>Xsel reserves the right to modify or cancel this promotion at any time without prior notice.
                    </li>
                </ul>
 
                <h4>Technical Issues</h4>
                <ul>
                    <li>Xsel is not responsible for technical difficulties or disruptions that may prevent users from
                        completing their purchases during the promotional period.</li>
                </ul>
 
                <h4>Governing Law</h4>
                <ul>
                    <li>These terms and conditions are governed by the laws of the jurisdiction in which C21 Path to
                        Gold operates.</li>
                </ul>
 
                <h4>Contact Information</h4>
                <ul>
                    <li>For any questions or concerns, please contact our customer support team at <a
                            href="mailto:support@xsel.app">support@xsel.app</a>.</li>
                </ul>
            </div>
        </div>
    </div>
</section>
        </Modal.Body>
      </Modal>
        </>
    )

}
export default FlashTermAndCondModal;